import './testimonials.css';
import Training3 from '../../assets/Training3.png';
import Training6 from '../../assets/Training6.png';
import Training8 from '../../assets/Training8.png';
import Training7 from '../../assets/Training7.png';

const testimonials = () => {
    return (
        <section id="testimonials">
            <h5>Certifications | Trainings</h5>
            <h2>Development Certifications</h2>

            <div className="container testimonials__container">
                <article className="testimonial">
                    <div className="client__avatar">
                        <h5 className='client__name'>TypeScript: OOP</h5>
                        <small className='client__review'>
                            <img src={Training3} alt="" />
                        </small>
                    </div>
                </article>
                <article className="testimonial">
                    <div className="client__avatar">
                        <h5 className='client__name'>Software Design</h5>
                        <small className='client__review'>
                            <img src={Training7} alt="" />
                        </small>
                    </div>
                </article>
                <article className="testimonial">
                    <div className="client__avatar">
                        <h5 className='client__name'>Webpack 4</h5>
                        <small className='client__review'>
                            <img src={Training8} alt="" />
                        </small>
                    </div>
                </article>
                <article className="testimonial">
                    <div className="client__avatar">
                        <h5 className='client__name'>Angular CLI</h5>
                        <small className='client__review'>
                            <img src={Training6} alt="" />
                        </small>
                    </div>
                </article>
            </div>

        </section>
    )
}

export default testimonials;
